const typography = {
  h1: {
    fontFamily: "Roboto",
    fontWeight: 300,
    fontSize: 40,
  },
  h2: {
    fontFamily: "Roboto",
    fontWeight: "300",
    fontSize: 30,
  },
  h3: {
    fontFamily: "Roboto",
    fontWeight: 400,
    fontSize: 24,
  },
  h4: {
    fontFamily: "Roboto",
    fontWeight: 400,
    fontSize: 20,
  },
  h5: {
    fontFamily: "Roboto",
    fontWeight: 500,
    fontSize: 16,
  },
  h6: {
    fontFamily: "Roboto",
    fontWeight: 500,
    fontSize: 14,
    lineHeight: 1.5,
  },
  subtitle1: {
    fontFamily: "Roboto",
    fontWeight: "normal",
    fontSize: 12,
    color: "#808080",
    lineHeight: 1.5,
  },
  subtitle2: {
    fontFamily: "Roboto",
    fontWeight: "normal",
    fontSize: 11,
    lineHeight: 1.5,
  },
  body1: {
    fontFamily: "Roboto",
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 1.5,
  },
  body2: {
    fontFamily: "Roboto",
    fontWeight: 500,
    fontSize: 14,
    lineHeight: 1.5,
  },
  button: {
    fontFamily: "Roboto",
    fontWeight: 500,
    fontSize: 14,
  },
  caption: {
    fontFamily: "Roboto",
    fontWeight: "normal",
    fontSize: 12,
  },
  overline: {
    fontFamily: "Roboto",
    fontWeight: 500,
  },
};

export default typography;
